export const education = [
  {
    degreeName: "B.Sc",
    subject: "Computer Science and Engineering",
    passingYear: "2021",
    istitution: "BRAC University",
    duration: "5 years",
    img: "https://i.ibb.co/JcNF8ZW/bracu.jpg",
  },
  {
    degreeName: "HSC",
    subject: "Science",
    passingYear: "2015",
    istitution: "Govt. City College, Chiggatiog",
    duration: "2 years",
    img: "https://i.ibb.co/fqTQT0K/city-College.jpg",
  },
  {
    degreeName: "SSC",
    subject: "Science",
    passingYear: "2013",
    istitution: "BN School & College, Chiggatiog",
    duration: "10 years",
    img: "https://i.ibb.co/gPj0yFb/bn.jpg",
  },
];
